import React, { Suspense, lazy } from "react";
import { Link } from "react-scroll";
import Header from "./Header";
import bgGra from "../Utils/Images/bgGra-01.svg";
import bgGraMob from "../Utils/Images/bggra-mob-06.svg";
import webProg from "../Utils/Images/coding.png";

// Lazy load heavy components
const Projects = lazy(() => import("./Projects"));
const About = lazy(() => import("./About"));
const Experiance = lazy(() => import("./Experiance"));
const Footer = lazy(() => import("./Footer"));
const AnimatedCircle = lazy(() => import("./AnimatedCircle"));

// Lazy load Spline
const Spline = lazy(() => import("@splinetool/react-spline"));



const Body = ({ setDarkMode }) => {
  return (
    <div className="w-full bg-[#eae7e7] dark:bg-customBlack dark:text-white">
      <Header setDarkMode={setDarkMode} />

      <div className="relative w-full h-full">

        {/* Lazy Animated Circle */}
        <Suspense fallback={null}>
          <AnimatedCircle />
        </Suspense>

        <div className="relative w-full overflow-hidden">
          {/* Lazy images */}
          <img
            loading="lazy"
            className="lg:hidden relative w-full h-[620vh] object-cover"
            src={bgGraMob}
            alt="HomeBg"
          />

          <img
            loading="lazy"
            className="hidden lg:block relative w-full object-cover"
            src={bgGra}
            alt="HomeBg"
          />

          {/* Lazy Spline */}
          <div className="absolute top-0 w-full h-[100vh] md:w-[112%] overflow-hidden">
            <Suspense fallback={<div className="w-full h-full" />}>
              <Spline scene="https://prod.spline.design/AT7tT4rsgu0PICB1/scene.splinecode" />
            </Suspense>
          </div>

          {/* HERO SECTION */}
          <div
            id="home"
            className="absolute top-36 lg:top-48 left-0 w-[35vh] md:w-[95vh] pl-6 lg:px-[9%] z-10 text-3xl lg:text-7xl"
          >
            <h3 className="font-iDroid">
              Dhai<span className="text-pink-400">r</span>ya
            </h3>

            <div className="flex">
              <img
                loading="lazy"
                className="w-6 h-6 lg:w-14 lg:h-14 lg:mt-3 dark:invert"
                src={webProg}
                alt="progIcon"
              />
              <h3 className="lg:ml-11 ml-2 font-iDroid">
                Fr<span className="text-coustomGreen">o</span>ntend
              </h3>
            </div>

            <h3 className="font-iDroid">
              d<span className="text-pink-400">e</span>vel
              <span className="text-coustomGreen">o</span>per
            </h3>

            <div className="my-4">
              <h2 className="text-xl lg:text-3xl">
                Transforming Concepts into Seamless User Experiences.
              </h2>
            </div>

            <div className="mt-8 lg:mt-10">
              <button className="flex relative z-30 items-center justify-center overflow-hidden text-sm lg:text-xl text-white bg-coustomGreenBg my-4 py-1 border rounded-full shadow-2xl transition-all before:absolute before:h-0 before:w-0 before:rounded-full before:bg-coustomGreen before:duration-500 before:ease-out hover:shadow-coustomGreen hover:before:h-72 hover:before:w-72">
                <Link
                  className="flex items-center"
                  to="projects"
                  smooth={true}
                  offset={-30}
                  duration={1000}
                >
                  <span className="pl-3 lg:pb-1 lg:pl-5 relative z-10">
                    Take a look at my work
                  </span>

                  <img
                    loading="lazy"
                    className="w-8 h-8 p-1 ml-2 mr-1 bg-white rounded-full relative z-10"
                    src="https://www.svgrepo.com/show/349679/arrow-up-right.svg"
                    alt="visitIcon"
                  />
                </Link>
              </button>
            </div>
          </div>
        </div>

        {/* Lazy load below-fold components */}
        <div className="absolute mt-[10%] top-[10%] lg:top-[72vh] w-full">
          <Suspense fallback={<div className="text-center py-10">Loading...</div>}>
            <About />
            <Projects />
            <Experiance />
            <Footer />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default Body;
